
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Cpu, Zap, Upload, Download, LayoutDashboard } from "lucide-react";

export function Navigation() {
  // Get current location from React Router
  const location = useLocation();
  
  const isPublicDomain =
    typeof window !== 'undefined' &&
    ['perpetualplexus.nl', 'www.perpetualplexus.nl'].includes(window.location.hostname.toLowerCase());

  const dashboardHref = isPublicDomain ? "/dashboard" : "/";

  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  const links = [
    {
      name: "Dashboard",
      href: dashboardHref,
      icon: LayoutDashboard
    },
    {
      name: "Devices",
      href: "/devices",
      icon: Cpu
    },
    {
      name: "Firmware",
      href: "/firmware",
      icon: Upload
    },
    {
      name: "Diagnostic",
      href: "/diagnostic", 
      icon: Zap
    },
    {
      name: "Setup",
      href: "/setup", 
      icon: Upload
    }
  ];

  return (
    <div className="bg-white shadow-sm">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between py-4 px-4">
        <div className="flex items-center mb-4 sm:mb-0">
          <Link to="/" className="flex items-center">
            <img 
              src="/lovable-uploads/efa069bf-9d2b-431a-bde8-23163003d9ce.png" 
              alt="Perpetual Plexus Logo" 
              className="h-12 mr-4"
            />
            <span className="font-bold text-xl">Perpetual Plexus network activity detector</span>
          </Link>
        </div>
        
        <nav className="flex space-x-1">
          {links.map((link) => {
            const Icon = link.icon;
            return (
              <Link
                key={link.href}
                to={link.href}
                className={cn(
                  "px-3 py-2 rounded-md text-sm font-medium flex items-center",
                  isActive(link.href) 
                    ? "bg-gray-900 text-white" 
                    : "text-gray-700 hover:bg-gray-200"
                )}
              >
                <Icon className="h-4 w-4 mr-2" />
                <span>{link.name}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
